import React from 'react';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import styles from './categoryOne.module.scss';
import {
  Category1TypeFields,
  Category1Types,
  Category1TypeSections,
} from 'enums/category1Enums';
import COButton from 'shared/components/COButton';
import Catgeory1Layout from 'views/Scope3/Category1/category1Layout';
import { UseFieldArrayAppend, UseFieldArrayRemove } from 'react-hook-form';
import {
  ScopeThreeCategoryOne,
  ScopeThreeSection,
} from 'models/ScopeThreeCategoryOne/ScopeThreeCategoryOne.model';
import { RawMaterialIngredientsMeta } from 'models/RawMaterialIngredientsMeta/rawMaterialIngredientsMeta.model';
import ErrorIcon from './ErrorIcon';

interface PanelComponentProps {
  fields: Record<'id', string>[];
  append: UseFieldArrayAppend<
    ScopeThreeCategoryOne,
    Category1TypeFields.INGREDIENTS
  >;
  appendPackagingMaterial: UseFieldArrayAppend<
    ScopeThreeCategoryOne,
    Category1TypeFields.PACKAGING_MATERIALS
  >;
  appendOtherMaterial: UseFieldArrayAppend<
    ScopeThreeCategoryOne,
    Category1TypeFields.OTHERS
  >;
  remove: UseFieldArrayRemove;
  packagingMaterialFields: Record<'id', string>[];
  removePackagingMaterial: UseFieldArrayRemove;
  otherMaterialFields: Record<'id', string>[];
  removeOtherMaterial: UseFieldArrayRemove;
  rawMaterialIngredientsMeta?: RawMaterialIngredientsMeta[];
  rawMateialPackagingMeta?: RawMaterialIngredientsMeta[];
  othersMeta?: RawMaterialIngredientsMeta[];
  isAccordionOpen?: boolean;
  setActiveTabKey?: React.Dispatch<React.SetStateAction<string | string[]>>;
  errorList: String[];
  isEditView?: boolean;
}

export const PanelComponent = (props: PanelComponentProps) => {
  const {
    fields,
    append,
    appendPackagingMaterial,
    appendOtherMaterial,
    remove,
    packagingMaterialFields,
    removePackagingMaterial,
    otherMaterialFields,
    removeOtherMaterial,
    rawMaterialIngredientsMeta,
    rawMateialPackagingMeta,
    othersMeta,
    setActiveTabKey,
    errorList,
    isEditView = true,
  } = props;

  const handleAdd =
    (type: Category1TypeFields) =>
    (event?: React.MouseEvent<HTMLDivElement>) => {
      if (!isEditView) return;
      event?.stopPropagation();
      switch (type) {
        case Category1TypeFields.INGREDIENTS:
          append(new ScopeThreeSection(), { shouldFocus: false });
          setActiveTabKey?.('1');
          break;
        case Category1TypeFields.PACKAGING_MATERIALS:
          appendPackagingMaterial(new ScopeThreeSection(), {
            shouldFocus: false,
          });
          setActiveTabKey?.('2');
          break;
        case Category1TypeFields.OTHERS:
          appendOtherMaterial(new ScopeThreeSection(), { shouldFocus: false });
          setActiveTabKey?.('3');
          break;
      }
    };

  return [
    {
      key: '1',
      header: (
        <div>
          <div>
            Ingredients
            <ErrorIcon
              errorList={errorList}
              stringToCheck={Category1Types.INGREDIENTS}
            />
          </div>
          {isEditView && (
            <div
              className={styles.addAction}
              onClick={handleAdd(Category1TypeFields.INGREDIENTS)}>
              <COButton text>
                <AddIcon />
                {Category1TypeSections.INGREDIENTS}
              </COButton>
            </div>
          )}
        </div>
      ),
      content: (
        <div className={styles.accordionContainer}>
          <div className={styles.accordionContentContainer}>
            {fields.map((field, index) => {
              return (
                <div key={field.id}>
                  <Catgeory1Layout
                    index={index}
                    type={Category1Types.INGREDIENTS}
                    remove={remove}
                    ingredientsMeta={rawMaterialIngredientsMeta}
                    setActiveTabKey={setActiveTabKey}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ),
    },
    {
      key: '2',
      header: (
        <div>
          <div>
            Packaging Material
            <ErrorIcon
              errorList={errorList}
              stringToCheck={Category1Types.PACKAGING_MATERIALS}
            />
          </div>
          {isEditView && (
            <div
              className={styles.addAction}
              onClick={handleAdd(Category1TypeFields.PACKAGING_MATERIALS)}>
              <COButton text>
                <AddIcon />
                {Category1TypeSections.PACKAGING_MATERIALS}
              </COButton>
            </div>
          )}
        </div>
      ),
      content: (
        <div className={styles.accordionContainer}>
          <div className={styles.accordionContentContainer}>
            {packagingMaterialFields.map((field, index) => {
              return (
                <div
                  key={field.id}
                  className={styles.accordionContentContainer}>
                  <Catgeory1Layout
                    index={index}
                    type={Category1Types.PACKAGING_MATERIALS}
                    remove={removePackagingMaterial}
                    ingredientsMeta={rawMateialPackagingMeta}
                    setActiveTabKey={setActiveTabKey}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ),
    },
    {
      key: '3',
      header: (
        <div>
          <div>
            Others
            <ErrorIcon
              errorList={errorList}
              stringToCheck={Category1Types.OTHERS}
            />
          </div>
          {isEditView && (
            <div
              className={styles.addAction}
              onClick={handleAdd(Category1TypeFields.OTHERS)}>
              <COButton text>
                <AddIcon />
                {Category1TypeSections.OTHERS}
              </COButton>
            </div>
          )}
        </div>
      ),
      content: (
        <div className={styles.accordionContainer}>
          <div className={styles.accordionContentContainer}>
            {otherMaterialFields.map((field, index) => {
              return (
                <div key={field.id}>
                  <Catgeory1Layout
                    index={index}
                    type={Category1Types.OTHERS}
                    remove={removeOtherMaterial}
                    ingredientsMeta={othersMeta}
                    setActiveTabKey={setActiveTabKey}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ),
    },
  ];
};
